"use strict";
module.exports = require("./lib/client/number");



/*****************
 ** WEBPACK FOOTER
 ** ./~/griffin-paypal/number.js
 ** module id = 128
 ** module chunks = 2 6 9 10 11 12
 **/